var LocalSorter = (function () {
    function LocalSorter() {
    }
    LocalSorter.sort = function (data, field, direction, customCompare) {
        var dir = (direction === 'asc') ? 1 : -1;
        var compare = customCompare ? customCompare : this.COMPARE;
        return data.sort(function (a, b) {
            return compare.call(null, dir, a[field], b[field]);
        });
    };
    return LocalSorter;
}());
export { LocalSorter };
LocalSorter.COMPARE = function (direction, a, b) {
    if (a < b) {
        return -1 * direction;
    }
    if (a > b) {
        return direction;
    }
    return 0;
};
//# sourceMappingURL=local.sorter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-smart-table/lib/data-source/local/local.sorter.js
// module id = 415
// module chunks = 3